import { checkFileType } from '@/utils/file/checkFileType'

export const isVideoByName = (filename: string): boolean => checkFileType(filename, 'video')
